import React from 'react'
import Head from 'next/head'
import Link from 'next/link'
import Hero from '../components/Hero'
import Menu from '../components/Menu'
import Block from '../components/Block'
import { NextSeo } from 'next-seo';
import Footer from '../components/Footer'

export default () =>
  <div id="main-container">
    <NextSeo
      title='行動規範 | PyCon mini Hiroshima 2020 '
      description='PyCon mini Hiroshima 2020 の行動規範 code of conduct です。'
      openGraph={{
        title: '行動規範 | PyCon mini Hiroshima 2020',
        description: 'PyCon mini Hiroshima 2020 の行動規範 code of conduct です。'
      }}
    />
    <NextSeo 
    />
    <header>
      <Menu />
    </header>
    <div role='main'>
    <div>
      <h1 className='block'>PyCon mini Hiroshima 2020 行動規範</h1>
    </div>
    
    <Block title='行動規範' backgroundClass='not-center'>
      <p>PyCon mini Hiroshimaは、Pythonユーザが集まり、PythonやPythonを使ったソフトウェアについて情報交換、交流をするためのカンファレンスです。 PyCon mini Hiroshima の開催を通じて、Pythonの使い手が一堂に集まり、Pythonにまつわる様々な分野の知識や情報を交換し、新たな友達やコミュニティとのつながり、仕事やビジネスチャンスを増やせる場所とすることが目標です。</p>
      <p>ハラスメント行為には、言葉による性別、性的指向、障碍の有無、外見、身体の大きさ、人種、宗教に関する攻撃的なコメント、公的空間での性的な映像表現、意図的な威力行為、 ストーキング、つきまとい、写真撮影や録音によるいやがらせ、トークやその他のイベントに対して繰り返して中断しようとする行為、不適切な身体接触、そして望まれない性的な注意を引きつける行為を含みます。</p>
      <p>参加者は、これらのハラスメント行為を止めるように求められた場合、すぐに従わなければなりません。</p>
      <p>企業・団体パトロンおよび個人パトロンもまた反ハラスメント行為ポリシーに従わなければなりません。特に、性的な関心を引き起こす映像表現、活動、あるいはその他の物品を使うべきではありません。 性的な関心を引き起こすような服装/制服/コスチュームを使うべきではありませんし、その他の手段で性的な関心を引き起こすような環境を作ることもすべきではありません。</p>
      <p>参加者がハラスメント行為に属するふるまいをした場合、カンファレンス主催者は適切と判断した範囲で、当該行為を行った者に対する警告や、参加費を返還せずに会場から追放処分とするなどを含むいかなる行動も取ります。</p>
      <p>もしあなたがハラスメントに遭った場合、他の人がハラスメントに遭っている場合、あるいは他に気になることがあったときは、すぐに運営スタッフの誰かに連絡していただくようお願いします。</p>
      <p>運営スタッフは、ハラスメントを経験した人が、カンファレンス期間中安全かつ安心と感じられるように、参加者が会場の警備や近隣の警察に連絡すること、付き添い者の提供、およびその他の支援を行います。 私たちにとって大事なことは、あなたが安心してカンファレンスに参加できることです。私たちは参加者が会場にて、このルールに従うことを望みます。</p>
    </Block>

    <Block title='アクセシビリティ' backgroundClass='not-center'>
      <p>PyCon mini Hiroshima は皆さんが楽しめる場であってほしい。私たちは皆さんの参加を大切に思っています。</p>
      <p>私たちはカンファレンスがすべての参加者を等しく歓迎し、招き入れ、そして利用しやすいものになることを目指しています。以下の取り組みに関しては、カンファレンスの設計や運用に組み込んでいます:</p>
      <ul>
        <li>学生（社会人を除く）の参加を無料にします。</li>
        <li>イベント告知サイトとチケット販売サイトは Web アクセシビリティに配慮して技術の選定およびコンテンツの作成を進めています。</li>
      </ul>
      <p>しかし、アクセシビリティの問題はこれだけに限らず、さまざまであることも認識しています。</p>
      <p>アクセシビリティに関して上記以外の考慮事項を必要とされる方、またご意見やご質問のある方は、どうぞ、ご遠慮なく hiroshima@pycon.jp にご連絡ください。</p>
      <p>残念ながらすべてのご要望に必ずお応えできるとお約束することは困難ですが、それぞれのご事情をうかがって、できる限りの準備と対応をさせていただきます。</p>
    </Block>

    <Block title='プライバシーポリシー' backgroundClass='not-center'>
      <p>PyCon mini Hiroshima 2020 サイトは個人データを収集しておりません。</p>
      <p>hiroshima@pycon.jp への電子メールや「イベントへのお問い合わせ」に関する個人情報は、本イベント運営の目的に限って使用し、第三者に提供しません。</p>
      <p>チケット販売と参加者の管理には外部サービス (connpass) を使用します。</p>
      <p>また発表申込受付やアンケート等で Google フォームを使用します。</p>
      <p>これらは、それぞれのシステムの個人情報管理方針にご了承いただいたうえでご利用いただくものとします。</p>
    </Block>
    </div>

    <Footer/>
  </div>
